export const NO_SLACK_CODE = "NO_SLACK_CODE";
export const AUTHENTICATING_SLACK = "AUTHENTICATING_SLACK";
export const AUTHENTICATED_SLACK = "AUTHENTICATED_SLACK";
export const AUTHENTICATED_SLACK_ERROR = "AUTHENTICATED_SLACK_ERROR";
export const SLACK_ENDPOINT =
  "https://mighty-cove-70884.herokuapp.com/slack_auth";



// WEBPACK FOOTER //
// ./src/constants/slack.js